import { RemoteApiOpen } from 'src/data/usecases/open/open'
import { makeAxiosHttpClient } from 'src/main/factories/http/axios-http-client-factory-no-redirect-open'

export const makeRemoteOpen = (): any => new RemoteApiOpen('/login/microsoft', makeAxiosHttpClient())
